import React, { Component, Fragment } from "react";
import axios from "../../../../../axios-order";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/core/styles";
import {
  Paper,
  Button,
  Container,
  Grid,
  Card,
  CardHeader,
  CardContent,
  Box,
  Typography,
  Tab,
  Tabs,
  AppBar,
  FormControl,
  Select,
  MenuItem,
  InputLabel,
} from "@material-ui/core";
import Checkbox from "@material-ui/core/Checkbox";
import '../../../Loader.css'
import CircularProgress from "@mui/material/CircularProgress";
import Summary from "./summary";
import moment from "moment";
import MatchedInvoice from "./MatchedInvoice";
import MismatchedInvoice from "./MisMatched";
import MissingInAccount from "./MissingInAccount";
import MissingInGSTR from "./MissingInGSTR";
import VendorInvoiceSummary from "./VendorInvoiceSummary";
import AllInvoiceRecon from "./AllInvoiceRecon";
import ProbableMatchedInvoice from "./ProbableMatched";
import CryptoJS from "crypto-js";
import BoxWrapper from "../../../../../components/ui/boxWrapper";
import Snackbar from "@material-ui/core/Snackbar";
import MuiAlert from "@material-ui/lab/Alert";
import Modal from "react-bootstrap/Modal";
import { ValidatorForm } from "react-material-ui-form-validator";
import SelectField from "../../../../../components/ui/basicSelectInput";
import BasicInputField from "../../../../../components/ui/basicInput";
import ValidatedDatePicker from "../../../../../components/ui/monthWiseDatePicker";
import ValidatedMonthAndYearPicker from "../../../../../components/ui/monthWiseDatePicker";

// ─── SSE utilities (shared across all recons) ────────────────────────────────
import { generateUUID } from '../../../../../utils/sseUtils';
import { SSE_BASE_URL } from '../../../../../axios-order';
// ─────────────────────────────────────────────────────────────────────────────

const styles = function (theme) {
  return {
    root: {
      width: "400px",
    },
    tab: {
      [theme.breakpoints.up("md")]: {
        minWidth: "auto",
      },
    },
    formControl: {
      minWidth: 200,
      marginRight: theme.spacing(2),
    },
    runReportButton: {
      height: 40,
      marginTop: 16,
    },
  };
};

function TabPanel(props) {
  const { children, value, index, ...other } = props;
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`scrollable-auto-tabpanel-${index}`}
      aria-labelledby={`scrollable-auto-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box p={3}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

function a11yProps(index) {
  return {
    id: `scrollable-auto-tab-${index}`,
    "aria-controls": `scrollable-auto-tabpanel-${index}`,
  };
}

class Showdetails extends Component {
  constructor(props) {
    super(props);

    const decrypt = (data) => {
      return CryptoJS.enc.Base64.parse(data).toString(CryptoJS.enc.Utf8);
    };

    let activeUrl = window.location.href;
    let id = activeUrl.split("/");
    const decryptedId = decrypt(id[4]);

    this.state = {
      allGST2aReconReportData: {},
      tabValue: 0,
      loading: false,
      snackbarOpen: false,
      snackbarSeverity: "",
      message: "",
      selectedPeriod: "",
      thresholdValue: 5,
      isProcessing: false,
      processingMessage: '',
      reconId: decryptedId,
      showLogsModal: false,
      logsData: [],
      isLoadingLogs: false,
      logsPage: 0,
      logsRowsPerPage: 5,
      businessEntityId: null,
      openAndCloseModel: false,
      fromMonthAndYear: "",
      toMonthAndYear: "",
      forDisplayingFromMonthAndYear: "",
      forDisplayingToMonthAndYear: "",
      roundValue: "0",
      customRoundOff: "",
      trigarCustomRoundOff: false,
      trigarCircularProgress: false,
      errorMessage: "",
      colorForErrorMessage: "red",
      errorMessageVisibilityStyle: "hidden",
      errorMessageDisplayStyle: "none",
      isDownloading: false,
      progress: 0,
      isExportingLog: false,
      exportingLogId: null,

      // ── Advanced Criteria ──
      checked: false,
      forDisplayingFromMonthAndYearGSTR: "",
      forDisplayingToMonthAndYearGSTR: "",
      fromMonthAndYearGSTR: "",
      toMonthAndYearGSTR: "",
    };

    axios.get(`/gstr2a/summary/${decryptedId}`).then((res) => {
      if (res.data && res.data.status) {
            this.setState({
              allGST2aReconReportData: res.data.record,
              loading: false,
          reconId: decryptedId,
          businessEntityId: res.data.record?.business_entity_id || null,
            });
          }
    });
  }

  componentWillUnmount() {
    if (this.eventSource) {
      this.eventSource.close();
      this.eventSource = null;
  }
  }


  handleSnackbarOpen = (message, severity) => {
    this.setState({
      snackbarOpen: true,
      snackbarSeverity: severity,
      message: message,
    });
  };

  handleSnackbarClose = () => {
    this.setState({
      snackbarOpen: false,
      snackbarSeverity: "success",
      message: "",
    });
  };

  handleIconClick = (msg) => {
    this.setState({
      message: msg,
      snackbarOpen: true,
    });
  };


  downloadBase64File = (contentType, base64Data, fileName) => {
    const linkSource = `data:${contentType};base64,${base64Data}`;
    const downloadLink = document.createElement("a");
    downloadLink.href = linkSource;
    downloadLink.download = fileName;
    downloadLink.click();
  };

  downloadToExcel = () => {
    const contentType =
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
    const filename = `GSTR-2A_Reconciliation_Report.xlsx`;

    this.setState({ isDownloading: true, progress: 0 });

    axios
      .post(`/gstr2a/gstr2a_complete_summary/download`, {
        record: this.state.allGST2aReconReportData,
      })
      .then((res) => {
        this.downloadBase64File(contentType, res.data.file, filename);
      })
      .catch((error) => {
        console.log(error);
      })
      .finally(() => {
        this.setState({ isDownloading: false });
      });
  };


  handleTabChangeHandler = (event, newValue) => {
    this.setState({ tabValue: newValue });
  };

   handleBack = () => {
    this.props.history.push('/reconCards');
  };


  handlePeriodChange = (event) => {
    const selectedPeriod = event.target.value;

    if (selectedPeriod === "custom") {
      this.setState({
        selectedPeriod: '',
        openAndCloseModel: true,
        fromMonthAndYear: "",
        toMonthAndYear: "",
        forDisplayingFromMonthAndYear: "",
        forDisplayingToMonthAndYear: "",
        roundValue: "0",
        customRoundOff: "",
        trigarCustomRoundOff: false,
        trigarCircularProgress: false,
        errorMessage: "",
        colorForErrorMessage: "red",
        errorMessageVisibilityStyle: "hidden",
        errorMessageDisplayStyle: "none",
        // Advanced Criteria reset
        checked: false,
        forDisplayingFromMonthAndYearGSTR: "",
        forDisplayingToMonthAndYearGSTR: "",
        fromMonthAndYearGSTR: "",
        toMonthAndYearGSTR: "",
      });
    } else {
      this.setState({ selectedPeriod: selectedPeriod });
    }
  };


  handleViewLogs = () => {
    const gst = localStorage.getItem("gst");

    this.setState({
      isLoadingLogs: true,
      showLogsModal: true,
      logsData: []
    });

    axios
      .post(`/get_gst2a_recon_summary`, { gst: gst })
      .then((res) => {
        if (res.data && res.data.record) {
          const logsArray = Array.isArray(res.data.record)
            ? res.data.record
            : [res.data.record];
          this.setState({ logsData: logsArray, isLoadingLogs: false });
        } else {
          this.setState({ logsData: [], isLoadingLogs: false });
        }
      })
      .catch((error) => {
        console.error('Error fetching logs:', error);
        this.setState({ isLoadingLogs: false, showLogsModal: false });
      });
  };

  handleCloseLogsModal = () => {
    this.setState({ showLogsModal: false, logsData: [] });
  };

  handleExportLog = (reconId) => {
    const contentType =
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
    const filename = `GSTR-2A_Reconciliation_${reconId}.xlsx`;

    this.setState({ isExportingLog: true, exportingLogId: reconId })
    axios
      .get(`/gstr2a/summary/${reconId}`)
      .then((res) => {
        if (res.data.status && res.data.record) {
          return axios.post(`/gstr2a/gstr2a_complete_summary/download`, {
            record: res.data.record,
          });
        } else {
          throw new Error("No data available for this reconciliation");
        }
      })
      .then((res) => {
        this.downloadBase64File(contentType, res.data.file, filename);
      })
      .catch((error) => {
        console.error('Error exporting log:', error);
      })
      .finally(() => {
        this.setState({ isExportingLog: false, exportingLogId: null })
      });
  };


  handleOpenAndCloseModel = () => {
    this.setState({
      openAndCloseModel: !this.state.openAndCloseModel,
      trigarCircularProgress: false,
      colorForErrorMessage: "red",
      forDisplayingToMonthAndYear: "",
      forDisplayingFromMonthAndYear: "",
      fromMonthAndYear: "",
      toMonthAndYear: "",
      roundValue: "0",
      customRoundOff: "",
      trigarCustomRoundOff: false,
      errorMessage: "",
      errorMessageVisibilityStyle: "hidden",
      errorMessageDisplayStyle: "none",
      // Advanced Criteria reset
      checked: false,
      forDisplayingFromMonthAndYearGSTR: "",
      forDisplayingToMonthAndYearGSTR: "",
      fromMonthAndYearGSTR: "",
      toMonthAndYearGSTR: "",
    });
  };

  inputHandlerForYearAndFromMonth = (v) => {
    this.setState({ forDisplayingFromMonthAndYear: v });
    const current_date = new Date(v);
    const yy = current_date.getFullYear().toString();
    const mm = (current_date.getMonth() + 1).toString();
    const MonthAndYear = mm < 10 ? `0${mm}${yy}` : `${mm}${yy}`;
    this.setState({ fromMonthAndYear: MonthAndYear });
  };

  inputHandlerForYearAndToMonth = (v) => {
    this.setState({ forDisplayingToMonthAndYear: v });
    const current_date = new Date(v);
    const yy = current_date.getFullYear().toString();
    const mm = (current_date.getMonth() + 1).toString();
    const toMonthAndYear = mm < 10 ? `0${mm}${yy}` : `${mm}${yy}`;
    this.setState({ toMonthAndYear: toMonthAndYear });
  };

  // ── Advanced Criteria handlers ──
  handleChangeCheckbox = () => {
    this.setState({ checked: !this.state.checked });
  };

  inputHandlerForYearAndFromMonthGSTR = (v) => {
    this.setState({ forDisplayingFromMonthAndYearGSTR: v });
    const current_date = new Date(v);
    const yy = current_date.getFullYear().toString();
    const mm = (current_date.getMonth() + 1).toString();
    const MonthAndYear = mm < 10 ? `0${mm}${yy}` : `${mm}${yy}`;
    this.setState({ fromMonthAndYearGSTR: MonthAndYear });
  };

  inputHandlerForYearAndToMonthGSTR = (v) => {
    this.setState({ forDisplayingToMonthAndYearGSTR: v });
    const current_date = new Date(v);
    const yy = current_date.getFullYear().toString();
    const mm = (current_date.getMonth() + 1).toString();
    const MonthAndYear = mm < 10 ? `0${mm}${yy}` : `${mm}${yy}`;
    this.setState({ toMonthAndYearGSTR: MonthAndYear });
  };

  roundValueInputHandler = (e) => {
    const name = e.target.name;
    const value = e.target.value;
    if (name === "threshold_value" && value === 11) {
      this.setState({ roundValue: value, trigarCustomRoundOff: true });
    } else if (name === "threshold_value") {
      this.setState({ roundValue: value, trigarCustomRoundOff: false });
    } else if (name === "customRoundOff") {
      this.setState({ customRoundOff: value });
    }
  };


  initiateReconSSE = (sseToken) => {
    return new Promise((resolve, reject) => {

      if (this.eventSource) {
        this.eventSource.close();
        this.eventSource = null;
      }

      console.log("SSE Starting point");

      const url = `${SSE_BASE_URL}/api/sse/${sseToken}`;
      this.eventSource = new EventSource(url);

      console.log(
        "SSE object created:",
        url,
        "readyState:",
        this.eventSource.readyState
      );

      this.eventSource.onopen = () => {
        this._sseOpened = true;
        console.log('SSE onopen fired, readyState:', this.eventSource.readyState);
        resolve();
      };

      this.eventSource.onmessage = (event) => {
        console.log("RAW SSE:", event.data);
        try {
          const data = JSON.parse(event.data);
          console.log("REAL SSE DATA:", data);
          if (data.status === "done" || data.status === "Pass") {
            console.log("Recon completed via SSE, recon_id:", data.recon_id);
            if (this.eventSource) {
              this.eventSource.close();
              this.eventSource = null;
            }
            const reconId = data.recon_id || data.gstr2a_recon_id;
            this.fetchDetailedReport(reconId);
          }
        } catch (err) {
          console.log("Ignoring non-json SSE message:", event.data);
        }
      };

      this.eventSource.onerror = (e) => {
        const rs = this.eventSource?.readyState;
        console.log(
          "SSE onerror fired, readyState:", rs,
          "timestamp:", new Date().toISOString()
        );
        if (rs === 2) {
          console.log("SSE permanently closed (readyState 2)");
          if (this.eventSource) {
            this.eventSource.close();
            this.eventSource = null;
          }
          if (!this._sseOpened) {
            reject(new Error("SSE connection failed permanently"));
          }
        }
      };
    });
  };

  handleRunReport = async () => {
    const { selectedPeriod, thresholdValue, isProcessing } = this.state;

    if (isProcessing) return;

    try {
      this.setState({
        isProcessing: true,
        // processingMessage: 'Opening SSE connection...',
      });

      this._sseOpened = false;
      const sseToken = generateUUID();
      await this.initiateReconSSE(sseToken);
      console.log('SSE confirmed open. Starting recon POST.');

      this.setState({ processingMessage: 'Reconciliation is Running' });

      const payload = {
        org_gstin: localStorage.getItem("gst"),
        report_type: "gstr2a",
        business_entity_id: localStorage.getItem("business_entity_id"),
        period_type: selectedPeriod,
        threshold_value: thresholdValue,
        sse_token: sseToken,
        functionality: 'GSTR2A Recon',
      };
      const res = await axios.post(`/unified_auto_reconciliation`, payload);
      console.log('Recon API response:', res.data);

      if (!res.data || res.data.status === false) {
        if (this.eventSource) {
          this.eventSource.close();
          this.eventSource = null;
        }
        this.setState({ isProcessing: false, processingMessage: '' });
        this.handleSnackbarOpen('Failed to initiate reconciliation.', 'error');
        return;
      }

      this.handleSnackbarOpen('GSTR-2A Reconciliation is Running', 'info');

    } catch (err) {
      console.error('handleRunReport error:', err);
      if (this.eventSource) {
        this.eventSource.close();
        this.eventSource = null;
      }
      this.setState({ isProcessing: false, processingMessage: '' });
      this.handleSnackbarOpen('Error initiating reconciliation.', 'error');
    }
  };

  onCustomSubmitHandler = async () => {
    // Capture Advanced Criteria values before the modal reset clears them
    const advancedChecked = this.state.checked;
    const gstrFromMonth = this.state.fromMonthAndYearGSTR;
    const gstrToMonth = this.state.toMonthAndYearGSTR;
    const booksFromMonth = this.state.fromMonthAndYear;
    const booksToMonth = this.state.toMonthAndYear;

    this.setState({
      openAndCloseModel: false,
      trigarCircularProgress: false,
    });

    let roundValueData;
    if (this.state.roundValue === "11") {
      roundValueData = `${this.state.customRoundOff}`;
    } else {
      roundValueData = `${this.state.roundValue}`;
    }

    try {
      this.setState({
        isProcessing: true,
        // processingMessage: 'Opening SSE connection...',
      });

      this._sseOpened = false;
      const sseToken = generateUUID();

      await this.initiateReconSSE(sseToken);
      console.log('SSE confirmed open. Starting recon POST.');

      this.setState({ processingMessage: 'Custom Reconciliation is Running' });

      const payload = {
        org_gstin: localStorage.getItem("gst"),
        report_type: "gstr2a",
        business_entity_id: localStorage.getItem("business_entity_id"),
        period_type: "custom",
        threshold_value: parseInt(roundValueData),
        from_month: this.state.fromMonthAndYear,
        to_month: this.state.toMonthAndYear,
        // ── Same as 2B: always send books_* and gstr_* ──
        books_from_tax_period: booksFromMonth,
        books_to_tax_period: booksToMonth,
        gstr_from_tax_period: advancedChecked ? gstrFromMonth : booksFromMonth,
        gstr_to_tax_period: advancedChecked ? gstrToMonth : booksToMonth,
        sse_token: sseToken,
        functionality: 'GSTR2A Recon',
      };

      const res = await axios.post(`/unified_auto_reconciliation`, payload);
      console.log('Recon API response:', res.data);

      if (!res.data || res.data.status === false) {
        if (this.eventSource) {
          this.eventSource.close();
          this.eventSource = null;
        }
        this.setState({ isProcessing: false, processingMessage: '' });
        this.handleSnackbarOpen('Failed to initiate custom reconciliation.', 'error');
        return;
      }

      this.handleSnackbarOpen('Custom GSTR-2A Reconciliation is Running', 'info');

    } catch (err) {
      console.error('onCustomSubmitHandler error:', err);
      if (this.eventSource) {
        this.eventSource.close();
        this.eventSource = null;
      }
      this.setState({ isProcessing: false, processingMessage: '' });
      this.handleSnackbarOpen('Error initiating custom reconciliation.', 'error');
    }
  };

  fetchDetailedReport = (reconId) => {
    console.log("fetchDetailedReport called with:", reconId);
    if (!reconId) {
      this.setState({ isProcessing: false });
      this.handleSnackbarOpen('No recon ID received from SSE.', 'error');
      return;
    }
    axios.get(`/gstr2a/summary/${reconId}`)
      .then((res) => {
        if (res.data.status && res.data.record && !Array.isArray(res.data.record)) {
          this.updateReportData(res.data);
        } else {
          this.setState({ isProcessing: false, processingMessage: '' });
          this.handleSnackbarOpen('Failed to fetch report. Please refresh.', 'error');
        }
      })
      .catch(() => {
        this.setState({ isProcessing: false, processingMessage: '' });
        this.handleSnackbarOpen('Error loading report data.', 'error');
      });
  };

  updateReportData = (responseData) => {
    this.setState({
      allGST2aReconReportData: responseData.record,
      businessEntityId: responseData.record?.business_entity_id || this.state.businessEntityId,
      reconId: responseData.record?.id || this.state.reconId,
      isProcessing: false,
      processingMessage: '',
      loading: false,
    });

    toast.success("Report run successfully!", {
      position: "top-right",
      autoClose: 3000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
    });
  };


  formatMonth = (period) => {
    if (!period) return "-";
    const monthMap = {
      "01": "January", "02": "February", "03": "March", "04": "April",
      "05": "May", "06": "June", "07": "July", "08": "August",
      "09": "September", "10": "October", "11": "November", "12": "December",
    };
    if (period.length === 6) {
      const month = period.substring(0, 2);
      const year = period.substring(2, 6);
      return `${monthMap[month]}-${year}`;
    } else if (period.length === 2) {
      const currentYear = new Date().getFullYear();
      return `${monthMap[period]}-${currentYear}`;
    }
    return period;
  };


  render() {
    const { classes } = this.props;

    const periodOptions = [
      { value: "current_month", label: "Current Month" },
      { value: "previous_month", label: "Previous Month" },
      { value: "current_quarter", label: "Current Quarter" },
      { value: "previous_quarter", label: "Previous Quarter" },
      { value: "current_fy", label: "Current Financial Year" },
      { value: "previous_fy", label: "Previous Financial Year" },
      { value: "custom", label: "Custom" },
    ];

    return (
      <React.Fragment>
        <Container maxWidth={false} disableGutters>
          {this.state.loading === true && (
            <div style={{ textAlign: "center", marginTop: 50 }}>
              <CircularProgress />
              <br />
              Loading, Please wait...
            </div>
          )}

          {this.state.loading === false && (
            <>
              {/* ── Header ── */}
              <div style={{
                backgroundColor: "#f5f5f5",
                padding: "15px 20px",
                marginBottom: "0px",
              }}>
                <Grid container spacing={3} alignItems="center">

                  {/* Left — dates + back */}
                  <Grid item xs={3}>
                    <div style={{ fontSize: "12px", lineHeight: "1.8", marginBottom: "8px" }}>
                      Report Dated:{" "}
                      {Object.keys(this.state.allGST2aReconReportData).length > 0
                        ? moment(
                          this.state.allGST2aReconReportData.entity_details
                            ?.Reconciliation_Date
                        ).format("DD-MM-YYYY")
                      : ""}
                      <br />
                     Threshold Used: {this.state.allGST2aReconReportData.entity_details?.Threshold_Value}
                  </div>
                  <button
                    className="button-outlined-primary"
                      style={{ padding: "6px 20px", fontSize: "13px" }}
                    onClick={this.handleBack}
                  >
                    BACK
                  </button>
                </Grid>

                  {/* Center — title + export */}
                  <Grid item xs={6}>
                  <div style={{ textAlign: "center" }}>
                      <div style={{
                        fontSize: "18px",
                        fontWeight: "600",
                        marginBottom: "12px",
                        color: "#333",
                      }}>
                        GSTR-2A Reconciliation Report
                      </div>
                      <div style={{ display: "flex", gap: "12px", justifyContent: "center" }}>
                        <style>{`
  @keyframes spin {
    from { transform: rotate(0deg); }
    to   { transform: rotate(360deg); }
  }
`}</style>

                    <button
                      className="button-outlined-primary"
                      onClick={this.downloadToExcel}
                          disabled={this.state.isDownloading}
                          style={{
                            padding: "6px 24px",
                            fontSize: "13px",
                            display: "flex",
                            alignItems: "center",
                            gap: "8px",
                            opacity: this.state.isDownloading ? 0.85 : 1,
                            cursor: this.state.isDownloading ? "not-allowed" : "pointer"
                          }}
                          >
                          {this.state.isDownloading ? (
                            <>
                              <svg
                                width="16"
                                height="16"
                                viewBox="0 0 16 16"
                                style={{ animation: "spin 0.9s linear infinite", flexShrink: 0 }}
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <circle
                                  cx="8" cy="8" r="6"
                                  fill="none"
                                  stroke="currentColor"
                                  strokeWidth="2"
                                  strokeDasharray="28"
                                  strokeDashoffset="10"
                                  strokeLinecap="round"
                                />
                              </svg>
                              EXPORTING...
                            </>
                          ) : (
                            "EXPORT TO EXCEL"
                          )}
                          </button>
                        <button
                          className="button-outlined-secondary"
                          onClick={this.handleViewLogs}
                          style={{ padding: "6px 24px", fontSize: "13px" }}
                        >
                          LOGS
                    </button>
                  </div>
                    </div>
                </Grid>

                  {/* Right — period selector + run button */}
                  <Grid item xs={3}>
                    <div style={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "flex-end",
                      gap: "10px",
                    }}>
                      <div style={{
                        fontSize: "11px",
                        color: "#666",
                        marginBottom: "5px",
                        textAlign: "right",
                      }}>
                        {/* Report Period:{" "}
                        {Object.keys(this.state.allGST2aReconReportData).length > 0
                          ? this.state.allGST2aReconReportData.entity_details?.Period
                          : ""} */}
                            Books Period: {this.state.allGST2aReconReportData.entity_details?.books_period}
                      <br />
                      GSTR Period: {this.state.allGST2aReconReportData.entity_details?.gstr_period}
                  </div>

                      <div style={{
                        display: "flex",
                        gap: "10px",
                        alignItems: "center",
                        width: "100%",
                        justifyContent: "flex-end",
                      }}>
                        <FormControl
                          variant="outlined"
                          size="small"
                          style={{ minWidth: "180px", backgroundColor: "#fff" }}
                        >
                          <InputLabel></InputLabel>
                          <Select
                            value={this.state.selectedPeriod}
                            onChange={this.handlePeriodChange}
                            label="Period"
                            disabled={this.state.isProcessing}
                            displayEmpty
                          >
                            <MenuItem value="" disabled>Select Period</MenuItem>
                            {periodOptions.map((option) => (
                              <MenuItem key={option.value} value={option.value}>
                                {option.label}
                              </MenuItem>
                            ))}
                          </Select>
                        </FormControl>

                        <Button
                          variant="contained"
                          color="primary"
                          onClick={this.handleRunReport}
                          disabled={this.state.isProcessing || !this.state.selectedPeriod}
                          style={{
                            padding: "8px 20px",
                            fontWeight: "600",
                            whiteSpace: "nowrap",
                          }}
                        >
                          {this.state.isProcessing ? "PROCESSING..." : "RUN REPORT"}
                        </Button>
                      </div>

                      {this.state.isProcessing && (
                        <div style={{
                          marginTop: "4px",
                          padding: "8px 12px",
                          backgroundColor: "#e3f2fd",
                          borderRadius: "4px",
                          fontSize: "11px",
                          color: "#1976d2",
                          textAlign: "right",
                          border: "1px solid #90caf9",
                        }}>
                          {this.state.processingMessage}
                        </div>
                      )}
                    </div>
                </Grid>
              </Grid>
              </div>

              {/* ── Tabs ── */}
              <div className={classes.TabPanelSection}>
                <AppBar position="static" color="default">
                  <Tabs
                    value={this.state.tabValue}
                    onChange={this.handleTabChangeHandler}
                    indicatorColor="primary"
                    textColor="primary"
                    variant="scrollable"
                    scrollButtons="auto"
                    aria-label="scrollable auto tabs example"
                  >
                    <Tab classes={{ root: classes.tab }} style={{ background: "#fff", color: "#000" }} label="Summary" {...a11yProps(0)} />
                    <Tab classes={{ root: classes.tab }} style={{ background: "#28a745", color: "#fff" }} label="Matched Invoices" {...a11yProps(1)} />
                    <Tab classes={{ root: classes.tab }} style={{ background: "red", color: "#fff" }} label="Mismatch Invoices" {...a11yProps(2)} />
                    <Tab classes={{ root: classes.tab }} style={{ background: "#ddd", color: "#000" }} label="Probable Match" {...a11yProps(3)} />
                    <Tab classes={{ root: classes.tab }} style={{ background: "#ffad33", color: "#000" }} label="Missing in Accounts" {...a11yProps(4)} />
                    <Tab classes={{ root: classes.tab }} style={{ background: "#ffbf80", color: "#000" }} label="Missing in GSTR2A" {...a11yProps(5)} />
                    <Tab classes={{ root: classes.tab }} style={{ background: "#b3d9ff", color: "#000" }} label="Vendor wise Summary" {...a11yProps(6)} />
                    <Tab classes={{ root: classes.tab }} style={{ background: "#ffff4d", color: "#000" }} label="All Invoice(s) Recon" {...a11yProps(7)} />
                  </Tabs>
                </AppBar>

                <TabPanel value={this.state.tabValue} index={0}>
                  <BoxWrapper boxTitle="Summary">
                    <Summary
                      SummaryData={
                        Object.keys(this.state.allGST2aReconReportData).length > 0
                          ? this.state.allGST2aReconReportData.gstSummaryDashBoard
                          : []
                      }
                    />
                  </BoxWrapper>
                </TabPanel>

                <TabPanel value={this.state.tabValue} index={1}>
                  <MatchedInvoice
                    matchedInvoiceData={
                      Object.keys(this.state.allGST2aReconReportData).length > 0
                        ? this.state.allGST2aReconReportData.matched
                        : []
                    }
                  />
                </TabPanel>


                {/* .......Mis-Matched....... */}
                <TabPanel value={this.state.tabValue} index={2}>
                  <MismatchedInvoice
                    mismatchedInvoiceData={
                      Object.keys(this.state.allGST2aReconReportData).length > 0
                        ? this.state.allGST2aReconReportData.missMatched
                        : []
                    }
                  />
                </TabPanel>

                {/* ........Probable Matched........ */}
                <TabPanel value={this.state.tabValue} index={3}>
                  <ProbableMatchedInvoice
                    probableMatchedInvoiceData={
                      Object.keys(this.state.allGST2aReconReportData).length > 0
                        ? this.state.allGST2aReconReportData.ProbableMatching
                        : []
                    }
                  />
                </TabPanel>

                {/* .........Missing in Account......... */}
                <TabPanel value={this.state.tabValue} index={4}>
                  <MissingInAccount
                    missingInAccountData={
                      Object.keys(this.state.allGST2aReconReportData).length > 0
                        ? this.state.allGST2aReconReportData.missingInAccounts
                        : []
                    }
                  />
                </TabPanel>

                {/* Missing in GSTR1 */}
                <TabPanel value={this.state.tabValue} index={5}>
                  <MissingInGSTR
                    missingInGSTRData={
                      Object.keys(this.state.allGST2aReconReportData).length > 0
                        ? this.state.allGST2aReconReportData.missingInGstr
                        : []
                    }
                  />
                </TabPanel>

                {/* Vendor Invoice Summary */}
                <TabPanel value={this.state.tabValue} index={6}>
                  <VendorInvoiceSummary
                    VendorInvoiceSummaryData={
                      Object.keys(this.state.allGST2aReconReportData).length > 0
                        ? this.state.allGST2aReconReportData.VendorInvoiceSummary
                        : []
                    }
                  />
                </TabPanel>

                {/* All invoice Recon */}
                <TabPanel value={this.state.tabValue} index={7}>
                  <AllInvoiceRecon
                    AllInvoiceReconData={
                      Object.keys(this.state.allGST2aReconReportData).length > 0
                        ? this.state.allGST2aReconReportData.allInvoiceRecon
                        : []
                    }
                  />
                </TabPanel>
              </div>
            </>
          )}
        </Container>

        {/* ── Custom Reconciliation Modal ── */}
        <Modal
          size="lg"
          aria-labelledby="contained-modal-title-vcenter"
          centered
          show={this.state.openAndCloseModel}
          onHide={this.handleOpenAndCloseModel}
          dialogClassName="modal-50w"
        >
          <Modal.Header closeButton>
            <Modal.Title>GSTR-2A Reconciliation</Modal.Title>
          </Modal.Header>
          <ValidatorForm
            ref="form"
            onSubmit={this.onCustomSubmitHandler}
            onError={(errors) => console.log(errors)}
          >
            <Modal.Body>
              {/* Advanced Criteria checkbox */}
              <Grid item sm={12} container>
                <Checkbox
                  checked={this.state.checked}
                  onChange={this.handleChangeCheckbox}
                  color="primary"
                />
                <p
                  onClick={this.handleChangeCheckbox}
                  style={{ marginTop: "10px", fontSize: "16px", cursor: "pointer" }}
                >
                  Advanced Criteria
                </p>
              </Grid>

              {/* From / To Month */}
              <Grid container spacing={1}>
                {this.state.checked && (
                  <Grid item sm={12}>
                    <p style={{ marginTop: "14px", fontSize: "16px" }}>Books Period :</p>
                  </Grid>
                )}
                <Grid item sm={2}>
                  <p style={{ marginTop: "14px", fontSize: "16px" }}>
                    From Month<span style={{ color: "red" }}>*</span>:
                  </p>
                </Grid>
                <Grid item sm={4}>
                  <div style={{ marginTop: "10px" }}>
                    <ValidatedDatePicker
                      placeholder="Month & Year"
                      errorMessages={["This field is required"]}
                      validators={["required"]}
                      value={this.state.forDisplayingFromMonthAndYear}
                      onChange={(v) => this.inputHandlerForYearAndFromMonth(v)}
                    />
                  </div>
                </Grid>
                <Grid item sm={2}>
                  <p style={{ marginTop: "14px", fontSize: "16px" }}>
                    To Month<span style={{ color: "red" }}>*</span>:
                  </p>
                </Grid>
                <Grid item sm={4}>
                  <div style={{ marginTop: "10px" }}>
                    <ValidatedMonthAndYearPicker
                      minDateForDatepicker={this.state.forDisplayingFromMonthAndYear}
                      errorMessages={["This field is required"]}
                      validators={["required"]}
                      placeholder="Month & Year"
                      value={this.state.forDisplayingToMonthAndYear}
                      onChange={(v) => this.inputHandlerForYearAndToMonth(v)}
                    />
                  </div>
                </Grid>

                {/* GSTR-2A period (Advanced Criteria only) */}
                {this.state.checked && (
                  <>
                    <Grid item sm={12}>
                      <p style={{ marginTop: "14px", fontSize: "16px" }}>GSTR-2A Period :</p>
                    </Grid>
                    <Grid item sm={2}>
                      <p style={{ marginTop: "14px", fontSize: "16px" }}>
                        From Month<span style={{ color: "red" }}>*</span>:
                      </p>
                    </Grid>
                    <Grid item sm={4}>
                      <div style={{ marginTop: "10px" }}>
                        <ValidatedDatePicker
                          placeholder="Month & Year"
                          errorMessages={["This field is required"]}
                          validators={["required"]}
                          value={this.state.forDisplayingFromMonthAndYearGSTR}
                          onChange={(v) => this.inputHandlerForYearAndFromMonthGSTR(v)}
                        />
                      </div>
                    </Grid>
                    <Grid item sm={2}>
                      <p style={{ marginTop: "14px", fontSize: "16px" }}>
                        To Month<span style={{ color: "red" }}>*</span>:
                      </p>
                    </Grid>
                    <Grid item sm={4}>
                      <div style={{ marginTop: "10px" }}>
                        <ValidatedMonthAndYearPicker
                          minDateForDatepicker={this.state.forDisplayingFromMonthAndYearGSTR}
                          errorMessages={["This field is required"]}
                          validators={["required"]}
                          placeholder="Month & Year"
                          value={this.state.forDisplayingToMonthAndYearGSTR}
                          onChange={(v) => this.inputHandlerForYearAndToMonthGSTR(v)}
                        />
                      </div>
                    </Grid>
                  </>
                )}
              </Grid>

              {/* Threshold */}
              <Grid container spacing={1} style={{ marginTop: "20px" }}>
                <Grid item sm={2}>
                  <p style={{ marginTop: "10px", fontSize: "16px" }}>
                    Threshold value<span style={{ color: "red" }}>*</span>:
                  </p>
                </Grid>
                <Grid item sm={10}>
                  <SelectField
                    validator={["required"]}
                    errorMsg={["This field is required"]}
                    choice_id="id"
                    choice_name="roundOff"
                    name="threshold_value"
                    value={this.state.roundValue ?? "0"}
                    choices={[
                      { id: 0, roundOff: "No Threshold Value" },
                      { id: 1, roundOff: "Upto 1" },
                      { id: 5, roundOff: "Upto 5" },
                      { id: 10, roundOff: "Upto 10" },
                      { id: 11, roundOff: "Custom" },
                    ]}
                    textOnchangeFunction={this.roundValueInputHandler}
                  />
                </Grid>
              </Grid>

              {/* Custom threshold input */}
              {this.state.trigarCustomRoundOff && (
                <div style={{ marginTop: "20px" }}>
                  <Grid container spacing={3}>
                    <Grid item sm={3}>
                      <p style={{ marginTop: "10px", fontSize: "16px" }}>
                        Custom Round off<span style={{ color: "red" }}>*</span>:
                      </p>
                    </Grid>
                    <Grid item sm={9}>
                      <BasicInputField
                        inputType="number"
                        name="customRoundOff"
                        validator={["required"]}
                        errorMsg={["This field is required"]}
                        value={this.state.customRoundOff ?? ""}
                        textOnchangeFunction={this.roundValueInputHandler}
                      />
                    </Grid>
                  </Grid>
                </div>
              )}

              {/* Error / progress */}
              <div style={{
                color: this.state.colorForErrorMessage,
                paddingTop: "10px",
                fontWeight: "600",
                visibility: this.state.errorMessageVisibilityStyle,
                display: this.state.errorMessageDisplayStyle,
              }}>
                {this.state.errorMessage}
              </div>
              {this.state.trigarCircularProgress && (
                <div style={{ color: "green", paddingTop: "10px", fontWeight: "600" }}>
                  Please Wait......
                </div>
              )}
            </Modal.Body>
            <Modal.Footer>
              <div style={{ marginTop: "10px" }}>
                <button
                  className="button-primary"
                  type="submit"
                  disabled={this.state.isProcessing}
                >
                  {this.state.isProcessing ? "PROCESSING..." : "Submit"}
                </button>
                <button
                  type="button"
                  className="button-outlined-secondary"
                  onClick={this.handleOpenAndCloseModel}
                  disabled={this.state.isProcessing}
                >
                  Cancel
                </button>
              </div>
            </Modal.Footer>
          </ValidatorForm>
        </Modal>

        {/* ── Logs Modal ── */}
        <Modal
          size="xl"
          centered
          show={this.state.showLogsModal}
          onHide={this.handleCloseLogsModal}
          style={{ maxWidth: "90vw" }}
                >
          <Modal.Header
            closeButton
            style={{
              padding: '14px 20px',
              backgroundColor: '#03406d',
              borderBottom: 'none',
            }}
          >
            <Modal.Title style={{
              display: 'flex',
              alignItems: 'center',
              fontSize: '1rem',
              fontWeight: 600,
              color: '#fff',
            }}>
              <span style={{ marginRight: '8px' }}>⟲</span>
              GSTR-2A Reconciliation Logs
            </Modal.Title>
          </Modal.Header>

          <Modal.Body style={{ padding: 0 }}>
            {this.state.isLoadingLogs ? (
              <div style={{ textAlign: "center", padding: "40px" }}>
                <CircularProgress size={30} />
                <div style={{ fontSize: "14px", color: "#666", marginTop: "10px" }}>
                  Loading logs...
                </div>
              </div>
            ) : this.state.logsData.length === 0 ? (
              <div style={{ textAlign: "center", padding: "40px" }}>
                <div style={{ fontSize: "14px", color: "#999" }}>No logs available</div>
              </div>
            ) : (
              <div style={{ overflowX: "auto", maxHeight: "500px", overflowY: "auto" }}>
                <table style={{ width: "100%", borderCollapse: "collapse", fontSize: "13px" }}>
                  <thead>
                    <tr style={{ backgroundColor: "#f5f5f5" }}>
                      {["Recon ID", "Status", "Book From", "Book To","GST From", "GST To", "Threshold", "Date & Time", "Export"].map((h, i) => (
                        <th key={i} style={{
                          padding: "12px 16px",
                          textAlign: i === 1 || i === 4 || i === 6 ? "center" : "left",
                          fontWeight: "600",
                          fontSize: "11px",
                          color: "#666",
                          textTransform: "uppercase",
                          borderBottom: "1px solid #ddd",
                        }}>
                          {h}
                        </th>
                      ))}
                    </tr>
                  </thead>
                  <tbody>
                    {this.state.logsData
                      .slice(
                        this.state.logsPage * this.state.logsRowsPerPage,
                        this.state.logsPage * this.state.logsRowsPerPage + this.state.logsRowsPerPage
                      )
                      .map((log, index) => (
                        <tr
                          key={log.recon_id || index}
                          style={{
                            borderBottom: "1px solid #f0f0f0",
                            backgroundColor: index % 2 === 0 ? "#fff" : "#fafafa",
                          }}
                        >
                          <td style={{ padding: "12px 16px", color: "#333" }}>{log.recon_id || "-"}</td>
                          <td style={{ padding: "12px 16px", textAlign: "center" }}>
                            <span style={{
                              padding: "4px 12px",
                              borderRadius: "12px",
                              fontSize: "11px",
                              fontWeight: "600",
                              display: "inline-block",
                              textTransform: "uppercase",
                              backgroundColor: (log.recon_status === "Pass" || log.recon_status === "Completed") ? "#d4edda" : "#f8d7da",
                              color: (log.recon_status === "Pass" || log.recon_status === "Completed") ? "#155724" : "#721c24",
                            }}>
                              {log.recon_status || "Pass"}
                            </span>
                          </td>
                          <td style={{ padding: "12px 16px", color: "#555" }}>{this.formatMonth(log.books_from_tax_period)}</td>
                          <td style={{ padding: "12px 16px", color: "#555" }}>{this.formatMonth(log.books_to_tax_period)}</td>
                          <td style={{ padding: "12px 16px", color: "#555" }}>{this.formatMonth(log.gstr_from_tax_period)}</td>
                          <td style={{ padding: "12px 16px", color: "#555" }}>{this.formatMonth(log.gstr_to_tax_period)}</td>
                          <td style={{ padding: "12px 16px", textAlign: "center", color: "#555" }}>
                            {log.threshold_val !== undefined && log.threshold_val !== null ? log.threshold_val : "-"}
                          </td>
                          <td style={{ padding: "12px 16px", color: "#555" }}>{log.recon_date || "-"}</td>
                          <td style={{ padding: "12px 16px", textAlign: "center" }}>
                            {(log.recon_status === "Pass" || log.recon_status === "Completed") ? (
                              <button
                                onClick={() => this.handleExportLog(log.recon_id)}
                                disabled={this.state.isExportingLog && this.state.exportingLogId === log.recon_id}
                                style={{
                                  padding: "6px 10px",
                                  backgroundColor: "#28a745",
                                  color: "#fff",
                                  border: "none",
                                  borderRadius: "4px",
                                  cursor: (this.state.isExportingLog && this.state.exportingLogId === log.recon_id)
                                    ? "not-allowed" : "pointer",
                                  fontSize: "11px",
                                  display: "inline-flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                  minWidth: "34px",
                                  minHeight: "28px",
                                }}
                              >
                                {this.state.isExportingLog && this.state.exportingLogId === log.recon_id ? (
                                  <span
                                    style={{
                                      width: "12px",
                                      height: "12px",
                                      border: "2px solid currentColor",
                                      borderTopColor: "transparent",
                                      borderRadius: "50%",
                                      display: "inline-block",
                                      animation: "spin 0.7s linear infinite",
                                      flexShrink: 0,
                                    }}
                                  />
                                ) : (
                                  <svg width="14" height="14" viewBox="0 0 24 24" fill="none"
                                    stroke="currentColor" strokeWidth="2"
                                    style={{ verticalAlign: "middle" }}>
                                  <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path>
                                  <polyline points="7 10 12 15 17 10"></polyline>
                                  <line x1="12" y1="15" x2="12" y2="3"></line>
                                </svg>
                                )}
                              </button>
                            ) : (
                              <span style={{ color: "#999" }}>-</span>
                            )}
                          </td>
                        </tr>
                      ))}
                  </tbody>
                </table>
              </div>
            )}
          </Modal.Body>

          <Modal.Footer style={{
            padding: '12px 20px',
            borderTop: '1px solid #ddd',
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
          }}>
            <div style={{ fontSize: "12px", color: "#666" }}>
              Rows per page:
              <select
                value={this.state.logsRowsPerPage}
                onChange={(e) => this.setState({ logsRowsPerPage: parseInt(e.target.value, 10), logsPage: 0 })}
                style={{
                  marginLeft: '8px',
                  padding: '4px 8px',
                  border: '1px solid #ccc',
                  borderRadius: '3px',
                  fontSize: '12px',
                }}
              >
                <option value={5}>5</option>
                <option value={10}>10</option>
                <option value={25}>25</option>
                <option value={50}>50</option>
              </select>
              <span style={{ marginLeft: '16px' }}>
                {this.state.logsPage * this.state.logsRowsPerPage + 1}–
                {Math.min(
                  (this.state.logsPage + 1) * this.state.logsRowsPerPage,
                  this.state.logsData.length
                )}{" "}
                of {this.state.logsData.length}
              </span>
            </div>

            <div style={{ display: 'flex', gap: '6px' }}>
              <button
                onClick={() => this.setState({ logsPage: this.state.logsPage - 1 })}
                disabled={this.state.logsPage === 0}
                style={{
                  padding: '4px 10px',
                  border: '1px solid #ccc',
                  borderRadius: '3px',
                  backgroundColor: '#fff',
                  cursor: this.state.logsPage === 0 ? 'not-allowed' : 'pointer',
                  opacity: this.state.logsPage === 0 ? 0.5 : 1,
                }}
              >‹</button>
              <button
                onClick={() => this.setState({ logsPage: this.state.logsPage + 1 })}
                disabled={(this.state.logsPage + 1) * this.state.logsRowsPerPage >= this.state.logsData.length}
                style={{
                  padding: '4px 10px',
                  border: '1px solid #ccc',
                  borderRadius: '3px',
                  backgroundColor: '#fff',
                  cursor: (this.state.logsPage + 1) * this.state.logsRowsPerPage >= this.state.logsData.length ? 'not-allowed' : 'pointer',
                  opacity: (this.state.logsPage + 1) * this.state.logsRowsPerPage >= this.state.logsData.length ? 0.5 : 1,
                }}
              >›</button>
            </div>

            <button
              onClick={this.handleCloseLogsModal}
              style={{
                padding: '6px 20px',
                border: '1px solid #ccc',
                borderRadius: '3px',
                backgroundColor: '#fff',
                cursor: 'pointer',
                fontSize: '12px',
                textTransform: 'uppercase',
                fontWeight: '500',
              }}
            >
              CLOSE
            </button>
          </Modal.Footer>
        </Modal>

        {/* ── Snackbar ── */}
        <Snackbar
          anchorOrigin={{ vertical: "top", horizontal: "right" }}
                  open={this.state.snackbarOpen}
          autoHideDuration={5000}
                  onClose={this.handleSnackbarClose}
          style={{ maxWidth: "25%" }}
                >
                  <MuiAlert
            elevation={6}
            variant="filled"
                    onClose={this.handleSnackbarClose}
                    severity={this.state.snackbarSeverity}
                  >
                    {this.state.message}
                  </MuiAlert>
        </Snackbar>
      </React.Fragment>
    );
  }
}

Showdetails.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(Showdetails);